import { spawn } from 'redux-saga/effects';

import { sagas as postsSagas } from './postsModule';

export default function* sagas() {
	yield spawn(postsSagas);
}
